export default "__VITE_ASSET__DU4Vjom3__"